export const myFriendList = ({ all, myFriendListId }) => {
  if (!myFriendListId) {
    return null;
  }

  return all[myFriendListId] || null;
};

export const invitedFriendList = ({ all, invitedFriendListId }) => {
  if (!invitedFriendListId) {
    return null;
  }

  return all[invitedFriendListId] || null;
};

export const myFriendListParticipants = (state, getters) => {
  const friendList = getters.myFriendList;
  if (!friendList) {
    return [];
  }

  return getters
    .friendListParticipants(friendList.code)
    .filter(participant => participant.id !== friendList.customerId);
};

export const invitedFriendListParticipants = (state, getters) => {
  const friendList = getters.invitedFriendList;
  if (!friendList) {
    return [];
  }

  let participants = [...getters.friendListParticipants(friendList.code)];
  const index = participants.findIndex(
    participant => participant.id === friendList.customerId
  );

  let captain = null;
  if (index > 0) {
    captain = participants[index];
    participants.splice(index, 1);
    participants.unshift(captain);
  }

  return participants;
};

export const myFriendListParticipant = ({
  myFriendListId,
  participants,
}) => id => {
  if (!myFriendListId) {
    return null;
  }

  if (!participants[myFriendListId]) {
    return null;
  }

  return participants[myFriendListId][id] || null;
};

export const myFriendListId = ({ myFriendListId }) => {
  return myFriendListId;
};

export const myFriendListLevel = ({ all, myFriendListId }, getters) => {
  if (!myFriendListId || !all[myFriendListId]) {
    return null;
  }

  return getters.friendListLevelById(
    myFriendListId,
    all[myFriendListId].levelId
  );
};

export const friendListParticipants = ({ participants }) => id => {
  return Object.values(participants[id] || []).sort((a, b) => a.rank - b.rank);
};

export const friendLists = ({ all }) => {
  return Object.values(all);
};

export const friendListLevels = ({ levels }) => id => {
  if (!levels[id]) {
    return [];
  }

  return Object.values(levels[id]);
};

export const myFriendListLevels = ({ myFriendListId }, getters) => {
  return getters.friendListLevels(myFriendListId);
};

export const friendListById = ({ all }) => id => {
  return all[id] || null;
};

export const friendListLevelById = ({ levels }) => (friendListId, id) => {
  if (!levels[friendListId]) {
    return null;
  }

  return levels[friendListId][id] || null;
};

export const myFriendListLevelById = ({ myFriendListId }, getters) => id => {
  if (!myFriendListId) {
    return null;
  }

  return getters.friendListLevelById(myFriendListId, id);
};

export const hasFriendList = ({ myFriendListId }) => {
  return !!myFriendListId;
};

export const hasInvitedFriendList = ({ invitedFriendListId }) => {
  return !!invitedFriendListId;
};
